import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fa_product",
  "use": "icon-fa_product-usage",
  "viewBox": "180 220 600 580",
  "content": "<symbol viewBox=\"180 220 600 580\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fa_product\">\r\n  <path d=\"M200 360L480 240L760 360M200 360V660L480 780M760 360V660L480 780M480 240V780M340 300V500L400 460M640 420C673.137 420 700 446.863 700 480C700 513.137 673.137 540 640 540C606.863 540 580 513.137 580 480C580 446.863 606.863 420 640 420ZM640 480C640 491.046 648.954 500 660 500C671.046 500 680 491.046 680 480C680 468.954 671.046 460 660 460C648.954 460 640 468.954 640 480Z\" stroke=\"currentColor\" stroke-width=\"48\" stroke-linecap=\"round\" stroke-linejoin=\"round\" fill=\"none\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fa_product.svg
// module id = PRuN
// module chunks = 36